/**
* Created by vouill on 5/7/18.
*/

<template>
  <div>
    <SignForm
      @submit="resetPassword"
      :is-reset-password="true"
      :status="status"
    />
    <success-modal :is-active="status === 'success'"/>
  </div>
</template>

<script>
import SignForm from "../ui/sign-form";
import { actions, getApiStatus } from "vuex-api";
import { mapState } from "vuex";
import SuccessModal from "./success-modal";

export default {
  name: "ResetPassword",
  methods: {
    resetPassword: function({ email }) {
      this.$store.dispatch(actions.request, {
        requestConfig: {
          baseURL: process.env.VUE_APP_API_URL
        },
        method: "POST",
        url: "/api/users/reset-password",
        data: {
          email
        },
        keyPath: "newPassword"
        // onSuccess: {
        //   executeFunction: ({ data: { id_token } }) => {
        //     this.$store.dispatch(actions.request, {
        //       requestConfig: {
        //         baseURL: apiURL
        //       },
        //       method: "GET",
        //       url: "/api/users/me",
        //       headers: { Authorization: `Bearer ${id_token}` },
        //       keyPath: ["me"],
        //     });e
        //   }
        // }
      });
    }
  },
  computed: mapState({
    status: getApiStatus("newPassword")
  }),
  components: { SuccessModal, SignForm }
};
</script>
